import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, CanActivateChild, Router} from '@angular/router';
import { Observable } from 'rxjs';


import { map } from 'rxjs/operators';
import { Profilo } from '../interfaces/user';
import { UsersService } from '../services/user.service';

@Injectable({
	providedIn: 'root'
})
export class PermissionsGuard implements CanActivate, CanActivateChild {

	profile : Profilo;

	constructor(
		private usersService : UsersService,
		private router : Router
	) { }

	canActivate(
		next: ActivatedRouteSnapshot,
		state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
			return this.checkPermissions(next.data.permissions);
	}

	canActivateChild(
		next: ActivatedRouteSnapshot,
		state: RouterStateSnapshot
	) : Observable<boolean> | Promise<boolean> | boolean {
		return this.canActivate(next, state);
	}

	checkPermissions(permissions : string[]) : Observable<boolean> | boolean {
		this.profile = this.usersService.currentUser.value;
		if(this.profile){
			return this.checkFunctionalities(permissions);
		}else {
			return this.usersService.getProfile().pipe(
				map((profile : Profilo) => {
					if(profile.esito == 0) {
						this.profile = profile;
						return this.checkFunctionalities(permissions);
					}else {
						return false;
					}
				})
			)
		}
	}

	checkFunctionalities(operations : string[]) : boolean {
		if(!operations) {
			this.router.navigate([""]);
			return false;
		}
		for(let i = 0; i < operations.length; i++) {
			console.debug(operations[i],this.profile.Funzionalita.find(item => item.nome == operations[i]));
			if(!this.profile.Funzionalita.find(item => item.nome == operations[i]))
				return false;
		}
		return true;
	}
}
